import type { SceneLoadProgress } from '@/shared/config/splat-scene';
import styles from './loader.module.css';

export function ModelLoader({ progress }: { progress?: SceneLoadProgress | null }) {
  const preparing = progress?.phase === 'preparing';
  const total = progress?.total;
  const percent = preparing ? 100 : total && total > 0
    ? Math.min(100, Math.floor((progress!.loaded / total) * 100)) : null;

  return <div className={styles.loader} role="progressbar"
    aria-label={preparing ? 'Подготавливаем 3D-модель' : 'Загрузка модели'}
    aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent ?? undefined}
    aria-valuetext={preparing ? 'Файл загружен, готовим модель к показу' : percent === null ? 'Соединяемся с моделью' : `${percent}%`}
    data-indeterminate={percent === null} data-preparing={preparing}>
    <svg viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle className={styles.track} cx="32" cy="32" r="27" />
      <circle className={styles.arc} cx="32" cy="32" r="27" pathLength="100"
        strokeDasharray={`${percent === null ? 24 : percent} 100`} />
    </svg>
    <span aria-hidden="true">{percent === null ? '…' : percent}</span>
  </div>;
}
